<div class="default-dialog-layout">
    <div class="title">{{ data.title }}</div>
    <div class="content">
        <form #createFolderForm (ngSubmit)="confirm(newFolderName.value)">
            <cds-form-group>
                <cds-input>
                    <label>{{ data.inputLabel }}</label>
                    <input #newFolderName required type="text" maxlength="240" />
                </cds-input>
            </cds-form-group>
            <div class="actions action-buttons form-action-buttons">
                <cds-button size="sm" action="flat" type="button" (click)="cancel()">
                    {{ data.cancelButtonLabel || 'Cancel' }}
                </cds-button>
                <cds-button size="sm" type="submit" [disabled]="!createFolderForm.checkValidity()">
                    {{ data.confirmButtonLabel || 'Confirm' }}
                </cds-button>
            </div>
        </form>
    </div>
</div>
